import { render, staticRenderFns } from "./ProductCategoryItem.vue?vue&type=template&id=0a512a35&"
import script from "./ProductCategoryItem.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductCategoryItem.vue?vue&type=style&index=0&id=0a512a35&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports